import { CartUpdateEvent } from '@theme/events';

const strings = JSON.parse(document.getElementById('yk-commerce-strings')?.textContent || '{}');
let busy = false;
const quantities = form => [...form.querySelectorAll('input[type="number"]')];
function update(form) {
  const fields = quantities(form);
  const count = fields.reduce((sum, field) => sum + Number(field.value), 0);
  const valid = fields.every(field => field.validity.valid && Number.isInteger(Number(field.value)));
  form.querySelector('[data-yk-count]').textContent = strings.selected.replace('__COUNT__', String(count));
  form.querySelector('[data-yk-box-submit]').disabled = busy || !valid || count !== 4;
}
document.addEventListener('input', event => {
  const form = event.target.closest('[data-yk-builder]');
  if (form) update(form);
});
document.addEventListener('click', event => {
  const link = event.target.closest('a[href^="#yk-builder-"]');
  if (link) {
    const details = document.getElementById(link.hash.slice(1));
    if (details) {
      event.preventDefault();
      details.open = true;
      details.querySelector('summary').focus();
      details.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }
  const button = event.target.closest('[data-yk-add]');
  if (button) {
    event.preventDefault();
    if (!busy) add([{ id: button.dataset.ykAdd, quantity: 1 }], button, button.closest('[data-yk-addon]'));
  }
});
document.addEventListener('submit', event => {
  const form = event.target.closest('[data-yk-builder]');
  if (!form) return;
  event.preventDefault();
  if (busy) return;
  const fields = quantities(form);
  if (!fields.every(field => field.validity.valid && Number.isInteger(Number(field.value))) ||
      fields.reduce((sum, field) => sum + Number(field.value), 0) !== 4) {
    form.querySelector('[data-yk-status]').textContent = strings.chooseFour;
    return;
  }
  add(fields.filter(field => Number(field.value) > 0).map(field => ({
    id: field.name, quantity: Number(field.value)
  })), form.querySelector('[data-yk-box-submit]'), form);
});
async function add(items, button, scope) {
  busy = true;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  const status = scope.querySelector('[data-yk-status]');
  status.textContent = strings.adding;
  const root = window.Shopify?.routes?.root || '/';
  const sections = [...new Set([...document.querySelectorAll('cart-items-component')]
    .map(element => element.dataset.sectionId).filter(Boolean))].slice(0, 5);
  try {
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections, sections_url: location.pathname })
    });
    const added = await response.json();
    if (!response.ok || added.status) throw new Error('Addition failed');
    const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error('Cart refresh failed');
    const cart = await cartResponse.json();
    if (scope.matches('[data-yk-builder]')) quantities(scope).forEach(field => { field.value = '0'; });
    status.textContent = strings.added;
    document.dispatchEvent(new CartUpdateEvent(cart, 'yk-commerce', {
      source: 'yk-commerce', itemCount: cart.item_count, sections: added.sections
    }));
  } catch {
    status.textContent = strings.error;
  } finally {
    busy = false;
    button.disabled = false;
    button.removeAttribute('aria-busy');
    document.querySelectorAll('[data-yk-builder]').forEach(update);
  }
}
document.addEventListener('cart:update', event => {
  const items = event.detail?.resource?.items;
  if (!Array.isArray(items)) return;
  const ids = new Set(items.map(item => String(item.product_id)));
  document.querySelectorAll('[data-yk-addon]').forEach(card => {
    if (ids.has(card.dataset.ykAddon)) card.hidden = true;
  });
});
document.querySelectorAll('[data-yk-builder]').forEach(update);

